import React from 'react'
import PropTypes from 'prop-types'
import { LoadingDots } from '@entrata/portals-common/lib/components'
import styled from '@emotion/styled'

export const StyledDiv = styled('div')`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  color: white;
  justify-content: center;
  align-items: center;

  /* Hide loader in mobile/tablet for better UX */
  @media only screen and (max-width: 1024px) {
    display: none !important;
  }
`

export const StyledP = styled('p')`
  max-width: 320px;
  font-size: 18px;
  font-weight: 300;
  margin: 16px 0;
`

const Loader = ({ children }) => (
  <StyledDiv>
    <LoadingDots />
    {children && <StyledP>{children}</StyledP>}
  </StyledDiv>
)

Loader.propTypes = {
  children: PropTypes.node,
}

export default Loader
